<div
	gdColumns="repeat(auto-fill, minmax(180px, 1fr))"
	gdGap="10px"
	[formGroup]="form"
>
	<mat-form-field>
		<input
			matInput
			spellcheck="false"
			maxlength="30"
			autocomplete="off"
			placeholder="PO Number"
			formControlName="poNumber"
		/>
		<mat-error>Required</mat-error>
	</mat-form-field>

	<mat-form-field>
		<rpshared-currency-input
			placeholder="PO Amount"
			formControlName="poAmount"
		>
		</rpshared-currency-input>
	</mat-form-field>

	<mat-form-field gdColumn="1 / -1">
		<rpshared-currency-input
			matTooltip="Field cannot be edited"
			readonly
			placeholder="Estimated Spent to Date"
			formControlName="estimatedSpend"
		>
		</rpshared-currency-input>
	</mat-form-field>
	
	<rpshared-select-list
			required
			formControlName="alertThresholdPercentage"
			placeholder="Alert Threshold Percentage"
			[items]="alertThresholdPercentages"
			(selectionChange)="alertThresholdPercentageChange($event)"
			unit="%"
		></rpshared-select-list>

	<mat-form-field>
		<rpshared-currency-input
			placeholder="Alert Threshold Amount"
			formControlName="alertAmount"
			readonly="true"
		>
		</rpshared-currency-input>
	</mat-form-field>

	<rpshared-multi-chip-input
		gdColumn="1 / -1"
		placeholder="Send Alert Emails To"
		formControlName="alertEmailAddresses"
	></rpshared-multi-chip-input>
</div>
